import React, { useState, useEffect, useCallback, useContext  } from 'react';
import Etiqueta from './Etiqueta';
import { Get_type_tag_name } from '../Comun';
import { AuthContext } from '../contexts/AuthContext';

interface Tag 
{
  id: number;
  tag: string;
  valid_time: string;
  type_tag: number;
}

interface TagsProps 
{
  eventId: number;
  title: string;
  onBack: () => void;
}

const Etiquetas: React.FC<TagsProps> = ({ eventId, title, onBack }) => 
{
  const { token } = useContext(AuthContext);
  const [tags, setTags] = useState<Tag[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedTag, setSelectedTag] = useState<Tag | null>(null);

  //-----------------------------------------------------------

  const fetchTags = useCallback(async () => 
  {
    setLoading(true);
    try 
    {
      const api_url = process.env.REACT_APP_API_BASE_URL || '';
      const response = await fetch(`${api_url}web/get_event_tags?id_event=${eventId}`, {
        method: 'GET',
        headers: {'X-AUTH-TOKEN': token || ''},
      });

      if (response.ok) 
      {
        const data = await response.json();
        setTags(data);
      } 
      else 
      {
        throw new Error('Error al cargar tags.');
      }
    } 
    catch (error) 
    {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido';
      setError(errorMsg);
    } 
    finally 
    {
      setLoading(false);
    }
  }, [eventId, token]);

  //-----------------------------------------------------------

  useEffect(() => 
  {
    fetchTags();
  }, [fetchTags]);

  //-----------------------------------------------------------

  const handleCreateClick = () => 
  {
    setSelectedTag({
        id: -1, // Para indicar que es un nuevo evento
        tag: '',
        valid_time: '',
        type_tag: 0
      }); // Crear un tag vacío para la creación
  };

  //-----------------------------------------------------------

  const handleEditClick = (tag: Tag) => 
  {
    setSelectedTag(tag); // Para editar el tag existente
  };

  //-----------------------------------------------------------

  const handleFormClose = () => 
  {
    setSelectedTag(null); // Cerrar el formulario
    fetchTags(); // Refrescar la lista de eventos después de guardar o eliminar
  };

  //-----------------------------------------------------------

  return (
    <div className="eventos-container">
      <div className="miguitas">Etiquetas de {title}</div>
      {selectedTag === null ? (
        <div>
          <div>
            <table>
              <tbody>
                <tr>
                  <td>
                    <button onClick={onBack} className="create-client-button">
                      <i className="fas fa-chevron-left"></i> Volver a Eventos
                    </button>
                  </td>
                  <td>
                    <button
                      className="create-event-button"
                      onClick={handleCreateClick}
                    >
                      <i className="fas fa-plus-circle"></i> Crear TAG
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          {loading && <p>Buscando tags...</p>}
          {error && <p className="error-message">{error}</p>}
          {!loading && !error && tags.length === 0 && <p>No hay tags para mostrar.</p>}
          {!loading && !error && tags.length > 0 && (
            <table className="eventos-table">
              <tbody>
                {tags.map(tag => (
                  <tr key={tag.id}>
                    <td className="evento-name">{tag.tag}</td>
                    <td className="evento-autonext">
                      {Get_type_tag_name(tag.type_tag)}
                    </td>                    
                    <td className="evento-times">
                      {tag.valid_time}
                    </td>
                    <td className="evento-actions">
                      <button className="action-button edit-button" onClick={() => handleEditClick(tag)}><i className="fas fa-pencil"></i>Editar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        <div className="form-overlay">
          <Etiqueta
            tag={selectedTag}  
            id_event={eventId} // Pasar el id_evento para la creación de nuevos tags
            onSave={handleFormClose}
            onCancel={handleFormClose}
            onDelete={(tagId) => {
              setTags(tags.filter(tag => tag.id !== tagId));
              handleFormClose();
            }}
          />
        </div>
      )}
    </div>
  );
};


export default Etiquetas;
